function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3c09"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3c09"] = parcelRequire;
}
parcelRequire.register("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = {};
function $18c11f3350a906ea$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$18c11f3350a906ea$var$mapping[keys[i]] = pairs[keys[i]];
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $4903b9cb638b7600$exports = {};

(parcelRequire("27Lyk")).register(JSON.parse('{"d7mkx":"index.19574fbb.js","jNXQz":"sprite.fa7f9c96.svg"}'));

class $71a19ca4844e65f7$var$View {
    _parentEl = document.querySelector("#root");
    render(clear = false) {
        if (clear) this._clear();
        const html = this._generateHTML();
        this._parentEl.insertAdjacentHTML("beforeend", html);
    }
    _clear() {
        this._parentEl.innerHTML = "";
    }
}
var $71a19ca4844e65f7$export$2e2bcd8739ae039 = $71a19ca4844e65f7$var$View;


var $4f9ab47dbf027fd5$exports = {};

$4f9ab47dbf027fd5$exports = new URL((parcelRequire("27Lyk")).resolve("jNXQz"), import.meta.url).toString();


class $d8c7245dbd6c1e34$var$RatingView extends (0, $71a19ca4844e65f7$export$2e2bcd8739ae039) {
    handleRatingValue(handler) {
        this._parentEl.addEventListener("click", (e)=>{
            const valueBtn = e.target.closest(".rating__value-btn");
            // console.log(valueBtn);
            if (!valueBtn) return;
            const buttons = this._parentEl.querySelectorAll(".rating__value-btn");
            for (const btn of buttons)btn.classList.remove("checked");
            valueBtn.classList.add("checked");
            const value = valueBtn.dataset.value;
            handler(value);
        });
    }
    handleSubmitRating(handler) {
        this._parentEl.addEventListener("click", (e)=>{
            const submitBtn = e.target.closest(".rating__submit-btn");
            if (!submitBtn) return;
            handler(true);
        });
    }
    _generateHTML() {
        const HTML = `<div class="rating">
                        <div class="rating__icon-container">
                            <svg class="rating__icon">
                                <use xlink:href="${(0, (/*@__PURE__*/$parcel$interopDefault($4f9ab47dbf027fd5$exports)))}#icon-star"></use>
                            </svg>
                        </div>
                        <div class="rating__intro">
                            <h1>How did we do ?</h1>
                            <p>
                                Please let us know how we did with your support
                                request. All feedback is appreciated to help us
                                improve our offering!
                            </p>
                        </div>
                        <div class="rating__value-container">
                            <ul class="rating__values">
                                <li class="rating__value">
                                    <button type="radio" name="rate" class="rating__value-btn" data-value=${1}>1</button>
                                </li>
                                <li class="rating__value">
                                    <button type="radio" name="rate" class="rating__value-btn" data-value=${2}>2</button>
                                </li>
                                <li class="rating__value">
                                    <button type="radio" name="rate" class="rating__value-btn" data-value=${3}>3</button>
                                </li>
                                <li class="rating__value">
                                    <button type="radio" name="rate" class="rating__value-btn" data-value=${4}>4</button>
                                </li>
                                <li class="rating__value">
                                    <button type="radio" name="rate" class="rating__value-btn" data-value=${5}>5</button>
                                </li>
                            </ul>
                        </div>
                        <div class="rating__submit">
                            <button class="rating__submit-btn"><span>submit</span></button>
                        </div>
				</div>`;
        return HTML;
    }
}
var $d8c7245dbd6c1e34$export$2e2bcd8739ae039 = new $d8c7245dbd6c1e34$var$RatingView();




class $c53bfc34d7720a4a$var$ThanksView extends (0, $71a19ca4844e65f7$export$2e2bcd8739ae039) {
    _data = null;
    getData(data) {
        this._data = data;
    }
    _generateHTML = ()=>{
        const HTML = `
        <div class="thanks">
					<div class="thanks__icon-container">
						<svg class="thanks__icon">
                            <use
                                xlink:href="${(0, (/*@__PURE__*/$parcel$interopDefault($4f9ab47dbf027fd5$exports)))}#illustration-thank-you"></use>
                        </svg>
					</div>
					<div class="thanks_rate">
						<p>You selected <figure>${this._data}</figure> out of 5 </p>
					</div>
					<div class="thanks__dialogue">
						<h1>Thank you!</h1>
                        <div class="thanks__dialogue-content" >
                        
						<p>
							We appreciate you taking the time to give a rating.
						</p>
						<p>
							If you ever need more support, don't hesitate to get
							in touch!
						</p>
                        </div>
					</div>
				</div>`;
        return HTML;
    };
}
var $c53bfc34d7720a4a$export$2e2bcd8739ae039 = new $c53bfc34d7720a4a$var$ThanksView();


const $d7fcaaa29d0ffaa7$export$ca000e230c0caa3e = {
    rating: null
};
const $d7fcaaa29d0ffaa7$export$add41dbec41c3031 = (value)=>{
    $d7fcaaa29d0ffaa7$export$ca000e230c0caa3e.rating = value;
// console.log(state.rating);
};


const $d63a8266effe4d07$var$ratingValueControl = (value)=>{
    $d7fcaaa29d0ffaa7$export$add41dbec41c3031(value);
};
const $d63a8266effe4d07$var$controlRatingSubmission = (value)=>{
    if ($d7fcaaa29d0ffaa7$export$ca000e230c0caa3e.rating === null) return;
    (0, $c53bfc34d7720a4a$export$2e2bcd8739ae039).getData($d7fcaaa29d0ffaa7$export$ca000e230c0caa3e.rating);
    (0, $c53bfc34d7720a4a$export$2e2bcd8739ae039).render(value);
};
const $d63a8266effe4d07$var$init = ()=>{
    (0, $d8c7245dbd6c1e34$export$2e2bcd8739ae039).render();
    (0, $d8c7245dbd6c1e34$export$2e2bcd8739ae039).handleRatingValue($d63a8266effe4d07$var$ratingValueControl);
    (0, $d8c7245dbd6c1e34$export$2e2bcd8739ae039).handleSubmitRating($d63a8266effe4d07$var$controlRatingSubmission);
};
$d63a8266effe4d07$var$init();


//# sourceMappingURL=index.19574fbb.js.map
